import { ChatManager } from "@/components/chat";

import { ChatWorkspaceContentRedesigned } from "./ChatWorkspaceContentRedesigned";
import { ChatWorkspaceContentRedesignedV2 } from "./ChatWorkspaceContentRedesignedV2";

interface ChatWorkspaceContentProps {
    isChatWorkspaceRedesignEnabled: boolean;
    isChatWorkspaceRedesignV2Enabled: boolean;
}

export function ChatWorkspaceContent({
    isChatWorkspaceRedesignEnabled,
    isChatWorkspaceRedesignV2Enabled,
}: ChatWorkspaceContentProps) {
    if (isChatWorkspaceRedesignV2Enabled) {
        return <ChatWorkspaceContentRedesignedV2 />;
    }

    if (isChatWorkspaceRedesignEnabled) {
        return <ChatWorkspaceContentRedesigned />;
    }

    return <ChatManager />;
}
